import React from 'react'
import { Formik, Form, Field, FormikHelpers } from 'formik'
import * as yup from 'yup'
import { Button, InputField } from 'components'
import { useTranslation } from 'react-i18next'

interface PasswordResetEmailFormValues {
  email: string
}

const initialValues: PasswordResetEmailFormValues = {
  email: '',
}

const validationSchema = yup.object({
  email: yup
    .string()
    .email('pages.login.global.email.invalid')
    .required('pages.login.global.email.required'),
})

interface PasswordResetEmailFormProps {
  onSubmit: (
    values: PasswordResetEmailFormValues,
    formikHelpers: FormikHelpers<PasswordResetEmailFormValues>
  ) => void
}

export const PasswordResetEmailForm: React.FunctionComponent<PasswordResetEmailFormProps> = ({
  onSubmit,
}) => {
  const { t } = useTranslation()
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      <Form>
        <Field
          component={InputField}
          id="email"
          name="email"
          type="text"
          label={t('global.emailAddress')}
        />

        <Button type="submit" aria-label="Submit">
          {t('global.sendup')}
        </Button>
      </Form>
    </Formik>
  )
}
